import { Arrange, Button, SvgShare } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { requestVideoPlayerPause } from 'actions/videoPlayer';
import { DESKTOP_MIN_WIDTH, TABLET_MAX_WIDTH } from 'constants/breakpoints';
import { SHARE_BUTTON_CLICKED } from 'constants/events';
import { SHARE_UI_MODAL } from 'constants/modalTypes';
import * as analytics from 'utilities/analytics';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import CopyLinkIconButton from '../share-ui/share/link-section/CopyLinkIconButton';
import MediaQuery from '../../media-query';

const ShareModalButton = ({ userIsMemberOfVideoWorkspace, onClick }) => (
  <Button
    data-testid="share-modal-button"
    variant={userIsMemberOfVideoWorkspace ? 'primary' : 'neutral'}
    icon={<SvgShare />}
    onClick={onClick}
  >
    Share
  </Button>
);

const ShareButtonsWrapper = props => {
  const dispatch = useDispatch();
  const onShareModalClick = () => {
    dispatch(requestVideoPlayerPause());
    dispatch(openModal(SHARE_UI_MODAL));
    analytics.track(SHARE_BUTTON_CLICKED, {
      video_id: props.video.id,
    });
  };
  const isLoggedIn = Boolean(props.user?.id);

  const selectedWorkspace = useGetSelectedWorkspace();

  let userIsMemberOfVideoWorkspace = null;

  if (selectedWorkspace?.id) {
    userIsMemberOfVideoWorkspace =
      Number(selectedWorkspace.id) === props.video.organization_id;
  } else if (!isLoggedIn) {
    userIsMemberOfVideoWorkspace = false;
  }

  return (
    userIsMemberOfVideoWorkspace !== null && (
      <Arrange gap="small">
        <MediaQuery query={`(max-width: ${TABLET_MAX_WIDTH}px)`}>
          <CopyLinkIconButton videoId={props.video.id} />
          <ShareModalButton
            userIsMemberOfVideoWorkspace={userIsMemberOfVideoWorkspace}
            onClick={onShareModalClick}
          />
        </MediaQuery>
        <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
          <ShareModalButton
            userIsMemberOfVideoWorkspace={userIsMemberOfVideoWorkspace}
            onClick={onShareModalClick}
          />
          <CopyLinkIconButton videoId={props.video.id} />
        </MediaQuery>
      </Arrange>
    )
  );
};

export default ShareButtonsWrapper;
